module.exports = __webpack_public_path__ + "static/pizza_1-7b0d21988b1a84fe6f4cc1a979de9113.jpg";